import { useBCFirstRunState } from "@/hooks/useBCFirstRunState";
import { postRoute } from "@WahooFitness/wahoo-offline-mfe";
import { WSMBoltAppFirstRunState } from "@WahooFitness/wsm-native/dist/esm/types/bolt_cfg";
import { useEffect } from "react";

export const useCheckForOnboardingEffect = (appToken: string, connected: boolean) => {
  const { firstRunState } = useBCFirstRunState(appToken);
  useEffect(() => {
    // Ignore a "not done" state, as this is the default state
    if (
      connected &&
      firstRunState?.state !== undefined &&
      ![WSMBoltAppFirstRunState.Complete, WSMBoltAppFirstRunState.NotDone].includes(
        firstRunState.state
      )
    ) {
      postRoute("home");
    }
  }, [firstRunState, connected]);
};
